import { INavigateToNextStepOptions, SignupScreen, UserProfile } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { EnabledFeatures } from '../../../models/src';
import { IAppStore } from '../HomeWorkouts';
import Theme from '../theme';
import { UserDataConsumer } from '../utils';
import { appOnboardingStarted, getNextStep, navigateToNextStep } from './actions';
import { enabledFeaturesSelector, isLoadingEnabledFeaturesSelector } from './auth-selectors';
import { styles as SharedStyles } from './SignupFormsStyles';
import { INavigateToNextStep } from './types';

interface IProps {
  navigation: any;
  enabledFeatures: EnabledFeatures;
  isLoadingEnabledFeatures: boolean;
  onboardingStarted: boolean;
  screens: SignupScreen[];
  defaultScreen: SignupScreen[];
  user: {
    userProfile: UserProfile;
  };
  getNextStep(navigateToNextStep: INavigateToNextStep): void;
  navigateToNextStep(navigateToNextStep: any, options?: INavigateToNextStepOptions): void;
  appOnboardingStarted(userProfile: UserProfile, enabledFeatures: EnabledFeatures): void;
}
export class HomeOnBoardingStartScreen extends PureComponent<IProps, {}> {
  public componentDidMount = async () => {
    const { isLoadingEnabledFeatures } = this.props;
    if (!isLoadingEnabledFeatures) {
      this.handleNextStep();
    }
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any): void {
    const hasLoadedEnabledFeatures =
      prevProps.isLoadingEnabledFeatures === true &&
      this.props.isLoadingEnabledFeatures === false;
    if (hasLoadedEnabledFeatures) {
      this.handleNextStep();
    }
  }

  public render() {
    return (
      <View style={[SharedStyles.container, styles.container]}>
        <ActivityIndicator animating color={Theme.PRIMARY} />
      </View>
    );
  }

  private handleNextStep = () => {
    const {
      user: { userProfile },
      enabledFeatures,
    } = this.props;
    this.props.appOnboardingStarted(userProfile, enabledFeatures);
    this.props.getNextStep({
      currentScreen: SignupScreen.Start,
      userProfile: {},
    });
    this.props.navigateToNextStep(this.props.navigation, { isFirstScreenOnStack: true });
  }
}

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    screens: state.auth.signup.screens,
    enabledFeatures: enabledFeaturesSelector(state),
    isLoadingEnabledFeatures: isLoadingEnabledFeaturesSelector(state),
  };
};

const mapDispatchToProps = ({
  getNextStep,
  navigateToNextStep,
  appOnboardingStarted,
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: Theme.WHITE,
  },
});

export const HomeOnBoardingStart = connect(mapStateToProps, mapDispatchToProps)(
  UserDataConsumer(HomeOnBoardingStartScreen),
);
